module.exports = {"email":"Email","account_email":"Tu email de cuenta","password":"Contraseña","repeat_password":"Repite tu contraseña","firstname":"Nombre","lastname":"Apellido","special_ocation":"¿una ocasión especial?","comments":"¿Algún otro comentario que quieras dejar al restaurante? Ten en cuenta que no todas las solicitudes podrán ser atendidas (opcional)","choose":"Elige","male":"Masculino","female":"Femenino","search":" Busca un restaurante","password_not_match":"Repite tu contraseña correctamente","fill_your_data":"Completa tu información"}


//////////////////
// WEBPACK FOOTER
// ./src/app/locale/es/inputs.json
// module id = 727
// module chunks = 18